import { render, staticRenderFns } from "./_contact_form.vue?vue&type=template&id=874a7b00&scoped=true&"
import script from "./_contact_form.vue?vue&type=script&lang=js&"
export * from "./_contact_form.vue?vue&type=script&lang=js&"
import style0 from "./_contact_form.vue?vue&type=style&index=0&id=874a7b00&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874a7b00",
  null
  
)

export default component.exports